import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getRolesById,
  redirectToRolesList,
  rolesListFetch,
  deleteRoles,
} from "pages/AccessManagement/actions";
import { Header, SideBar, DeleteModal } from "CommonComponent";
import AddUpdateModel from "../AddUpdateModel";
import RolesViewModal from "../View";
import { ListHeader, DataTable } from './components';
import AccessRights from 'utils/AccessRights';
import { usersListFetch } from "pages/AccessManagement/actions/UsersActions";

const RoleList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const session = useSelector(state => state.session || {});
  const rolesState = useSelector(state => state.rolesState || {}); // ✅ Safe fallback

  const [showViewModel, setShowViewModel] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [addEditmodalShow, setAddEditModalShow] = useState(true);

  const object_viewed_id = session?.current_page_permissions?.object_id || '';

  useEffect(() => {
    dispatch(rolesListFetch(object_viewed_id));
  }, [dispatch, object_viewed_id]);

  useEffect(() => {
    setShowViewModel(rolesState.showViewPage === true);
  }, [rolesState.showViewPage]);

  useEffect(() => {
    setAddEditModalShow(false);
    dispatch(rolesListFetch(object_viewed_id));
  }, [rolesState.redirect_to_list, dispatch, object_viewed_id]);

  useEffect(() => {
    setAddEditModalShow(rolesState.showUpdateForm === true);
  }, [rolesState.showUpdateForm]);

  useEffect(() => {
    setShowViewModel(rolesState.showViewForm === true);
  }, [rolesState.showViewForm]);

  const showViewPopup = (recordId) => {
    dispatch(getRolesById(recordId, 'view'));
  };

  const showUpdateForm = (recordId) => {
    dispatch(getRolesById(recordId, 'update'));
  };

  const hideViewModel = () => {
    dispatch(redirectToRolesList());
  };

  const hideAddUpdateModel = () => {
    setAddEditModalShow(false);
    dispatch(redirectToRolesList());
  };

  const deleteRecord = async (deleteRowId) => {
    const object_viewed_id = session?.current_page_permissions?.object_id || '';
    await dispatch(deleteRoles(deleteRowId, object_viewed_id));
    setDeleteModalShow(false);
    await dispatch(rolesListFetch(object_viewed_id));
  };

  return (
    <>
      <div>
        <ListHeader
          setAddEditModalShow={setAddEditModalShow}
          addEditmodalShow={addEditmodalShow}
        />
        <div className="main-content-div page-card">
          <DataTable
            showViewPopup={showViewPopup}
            showUpdateForm={showUpdateForm}
            setDeleteRowId={setDeleteRowId}
            setDeleteModalShow={setDeleteModalShow}
          />
        </div>
        <DeleteModal
          show={deleteModalShow}
          onDelete={() => deleteRecord(deleteRowId)}
          onHide={() => setDeleteModalShow(false)}
        />
        <RolesViewModal
          show={showViewModel}
          onHide={hideViewModel}
        />
        <AddUpdateModel
          show={addEditmodalShow}
          onHide={hideAddUpdateModel}
        />
      </div>
    </>
  );
};

export default RoleList;
